<template>
  <v-row align="center" justify="center">
    <v-col class="text-center px-5 py-2" cols="12" md="9">
      <v-col cols="12">
        <v-btn
          icon
          title="Consulta por identificación"
          aria-label="Consulta por identificación"
        >
          <v-icon size="60">fas fa-address-card</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="mt-1">
        <span
          class="font-weight-bold leading--text mb-3"
          :style="
            $vuetify.breakpoint.xs ? 'font-size: 25px' : 'font-size: 32px'
          "
          >Consulta por identificación (CC / Nit / CE)</span
        >
      </v-col>

      <v-form ref="form" v-model="valid">
        <v-row align="center" justify="center">
          <v-col cols="10" md="8" class="mt-4">
            <div class="text-left font-weight-bold mb-5">
              Número de Documento
            </div>
            <v-text-field
              outlined
              counter
              v-model="idConsulta"
              @keypress.prevent.enter="getConsulta"
              placeholder="Ingrese dato.."
              oninput="this.value=this.value.replace(/[^0-9]/g,'');"
              :rules="nameRules"
              required
            >
            </v-text-field>
          </v-col>
        </v-row>
        <div class="mt-n2">
          <v-btn
            :loading="getStatus.loading"
            color="success"
            :class="
              `${$vuetify.breakpoint.xs ? 'mt-4 ' : ' '} mx-2 font-weight-bold`
            "
            width="200"
            aria-label="Consultar Número de radicación"
            @click="consultar"
            >Consultar</v-btn
          >
          <v-btn
            :class="
              `${$vuetify.breakpoint.xs ? 'mt-4 ' : ' '} mx-2 font-weight-bold`
            "
            width="200"
            dark
            color="grey"
            @click="reset"
            aria-label="Nueva Consulta Número de radicación"
            >Nueva Consulta</v-btn
          >
        </div>
      </v-form>
    </v-col>
  </v-row>
</template>
<script>
import Notifier from '@/components/Notifier';
import { mapGetters } from 'vuex';

export default {
  components: {
    Notifier,
  },
  data: () => ({
    valid: true,
    show: false,
    loading: false,
    consulted: false,
    dup: [],
    nameRules: [(v) => !!v || 'Número de Documento requerido'],
    idConsulta: '',
    status: {
      loading: false,
      error: false,
      message: '',
    },
    message: '',
  }),
  computed: {
    ...mapGetters("process", [
      "getProcesos",
      "getStatus",
      "getPaginaActualProcesos",
      "getPaginacionProcesos",
    ]),
  },
  created() {
    this.idConsulta = this.getSearch;
  },
  watch: {
    getPaginaActualProcesos(pagina) {
      if (this.getProcesos.length) {
        console.log(this.getProcesos);
        this.find();
      }
    },
  },
  // // watch: {
  // //   getPaginaActualProcesos(pagina) {
  // //     this.getConsulta();
  // //   },
  // // },
  methods: {
    // // async getConsulta() {
    // //   if (this.$refs.form.validate()) {
    // //     console.log(this.idConsulta)
    // //     await this.$store.dispatch('process/identificacion', this.idConsulta);
    // //     this.$emit('goToList');

    // //     if (!this.getProcesos.length) {
    // //       this.consulted = true;

    // //       if (!this.getStatus.error) {
    // //         this.$store.dispatch(
    // //           'process/mostrarNotificacionRespuestaVacia',
    // //           this.soloActivos
    // //         );
    // //       } else {
    // //         this.$store.dispatch('process/mostrarNotificacionError');
    // //       }
    // //     } else if (this.getProcesos.length > 1) {
    // //       this.consulted = true;
    // //       this.$store.dispatch('process/mostraNotificacionVariosRegistros');
    // //     }

    // //     this.duplicated = 0;
    // //   }
    // // },
    // // // reset() {
    // // //   this.show = false;
    // // //   this.$refs.form.reset();
    // // //   this.$refs.form.resetValidation();
    // // //   this.$store.dispatch('process/clearProcesos');
    // // //   if (this.$route.meta.active) {
    // // //     this.$router.push('/Procesos/NumeroRadicacion');
    // // //   }
    // // // },

    consultar() {
      if (this.$refs.form.validate()) {
        this.$emit("clear-process-id");
        this.$store.dispatch("process/setProcesos", []);
        this.$store.dispatch("process/setPaginaProcesos", 1);
        this.$store.commit("process/setPaginacion", {
          name: "paginacionProcesos",
          value: {
            ...this.getPaginacionProcesos,
            pagina: 1,
          },
        });
        this.find();
      }
    },
    async find() {
      if (this.$refs.form.validate()) {
        let payload = {
          id: this.idRadicacion,
          soloActivos: this.soloActivos,
        };

        await this.$store.dispatch("process/identificacion", this.idConsulta);
        this.$emit("goToList");

        if (!this.getProcesos.length) {
          this.consulted = true;

          if (!this.getStatus.error) {
            this.$store.dispatch(
              "process/mostrarNotificacionRespuestaVacia",
              this.soloActivos
            );
          } else {
            this.$store.dispatch("process/mostrarNotificacionError");
          }
        } else {
          if (this.getProcesos.length > 1) {
            this.consulted = true;
            this.$store.dispatch("process/mostraNotificacionVariosRegistros");
          }

          this.$emit("go-to-list");
        }
        this.duplicated = 0;
      }
    },
    reset() {
      this.show = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$store.dispatch("process/clearProcesos");
      // // this.idRadicacion = "";
      this.idConsulta = "";
      this.duplicated = 0;
    },


  },
};
</script>
